import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

type BulkCloseDealModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCount: number;
  isLoading: boolean;
};

export const BulkCloseDealModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCount,
  isLoading,
}: BulkCloseDealModalProps) => (
  <ActionaryModal
    dataTestId="bulk-close-deal-modal"
    description={
      <span className="body-base-regular text-text/secondary">
        {m.coInvestments_tracking_bulkCloseDeal_modalDescription({
          count: selectedCount.toString(),
        })}
      </span>
    }
    fluidHeight
    open={isOpen}
    setOpen={onClose}
    title={m.coInvestments_tracking_bulkCloseDeal_modalTitle()}
  >
    <div className="flex justify-end gap-3 pt-4">
      <ThemedButton
        dataTestId="cancel-bulk-close-deal-button"
        disabled={isLoading}
        onClick={onClose}
        size="default"
        type="button"
        variant="secondary"
      >
        {m.btn_cancel()}
      </ThemedButton>
      <ThemedButton
        dataTestId="confirm-bulk-close-deal-button"
        isLoading={isLoading}
        onClick={onConfirm}
        size="default"
        type="button"
        variant="primary"
      >
        {m.btn_confirm()}
      </ThemedButton>
    </div>
  </ActionaryModal>
);
